import React, { useState } from "react"
import { Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from "@mui/material"
import { dateFormat } from "../../../utils/date"
import { capitalizeEachWord } from "../../../utils/string"
import { currencyFormat } from "../../../utils/number"
import GenericTablePaginationActions from "../../../component/generic/GenericTablePaginationActions"

const columns = [
    { id: 'idUnidade', label: 'ID Unidade', minWidth: 80, align: 'left' },
    { id: 'unidadeName', label: 'Nome Unidade', minWidth: 80, align: 'center' },
    { id: 'idPedido', label: 'ID Pedido', minWidth: 100, align: 'center' },
    { id: 'tipoPedido', label: 'Origem', minWidth: 100, align: 'center' },
    { id: 'tipoPedidoDescricao', label: 'Tipo pedido', minWidth: 100, align: 'center' },
    { id: 'dataSaidaEntrada', label: 'Data Pedido', minWidth: 100, align: 'center' },
    { id: 'nomeCliente', label: 'Nome Cliente', minWidth: 100, align: 'center' },
    { id: 'valorTotal', label: 'Valor Total', minWidth: 100, align: 'right' },
]

export default function ListCustomer({ data }) {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data?.length) : 0

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    return (
        <TableContainer elevation={0} component={Paper}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column?.id}
                                align={column?.align}
                                style={{ minWidth: column?.minWidth, fontSize: '14px' }}
                            >
                                {column?.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {(rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data).map((row, index) => (
                        <TableRow key={row?.idPedido}>
                            <TableCell align="left">{row?.idUnidade}</TableCell>
                            <TableCell align="center">{capitalizeEachWord(row?.unidadeName)}</TableCell>
                            <TableCell align="center">{row?.idPedido}</TableCell>
                            <TableCell align="center">{row?.tipoPedido}</TableCell>
                            <TableCell align="center">{row?.tipoPedidoDescricao}</TableCell>
                            <TableCell align="center">{dateFormat(row?.dataSaidaEntrada)}</TableCell>
                            <TableCell align="center">{capitalizeEachWord(row?.nomeCliente)}</TableCell>
                            <TableCell align="right">{currencyFormat(row?.valorTotal)}</TableCell>
                        </TableRow>
                    ))}

                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={8} />
                        </TableRow>
                    )}
                </TableBody>

                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, { label: 'Todos', value: -1 }]}
                            colSpan={8}
                            count={data?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelRowsPerPage='linhas por página'
                            slotProps={{
                                select: {
                                    inputProps: {
                                        'aria-label': 'linhas por página',
                                    },
                                },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={GenericTablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    )
}